import React, { useState, useEffect } from "react";
import { useEditor } from "@craftjs/core";
import { Box, Grid } from "@material-ui/core";
import { ASSETS } from "../../../../utils/config";
import WidgetDisplay from "./children/WidgetDisplay";
import { openModal } from "../../../../redux/reducers/dialog";
import { useDispatch, useSelector } from "react-redux";
import { useClone } from "../../../../utils/contentBlocksEditorUtils";
import UndoRedoComponent from "../../../../pages/SegmentBuilder/UndoRedo";
import { IconButton } from "@mui/material";
import { deleteWheelMedia } from "../../../../services/api";
import { useParams } from "react-router-dom";

export const Settings = ({ setSelectedTab = () => { } }) => {
  const dispatch = useDispatch();
  const { actions, selected, isEnabled, query } = useEditor((state, query) => {
    const currentNodeId = query.getEvent("selected").last();
    let selectedNode;

    if (currentNodeId) {
      selectedNode = {
        id: currentNodeId,
        name: state.nodes[currentNodeId].data.name,
        settings:
          state.nodes[currentNodeId].related &&
          state.nodes[currentNodeId].related.settings,
        isDeletable: query.node(currentNodeId).isDeletable(),
      };

      if (selectedNode.name === "AccordionContainer") {
        const childNode = Object.values(state.nodes).find((node) => {
          if (node?.data?.name == "Accordion") return node || null;
        });

        if (childNode) {
          selectedNode = {
            id: childNode.id,
            name: childNode.data.displayName,
            settings: childNode.related && childNode.related?.settings,
            isDeletable: query.node(childNode.id).isDeletable(),
          };
        }
      }
    }
    return {
      selected: selectedNode,
      isEnabled: state.options.enabled,
    };
  });

  const { handleClone } = useClone(query, actions);

  const [initialState, setInitialState] = useState(null); // State to track the initial content
  const { id: wheelId } = useParams();


  useEffect(() => {
    // Track the initial state when the component mounts or content is loaded
    const currentState = query.getSerializedNodes();
    setInitialState(currentState);
  }, [query]); // Runs on every editor update

  const handleCloseSettings = () => {
    actions.selectNode(null);
    setSelectedTab("0");
  };

  const onConfirm = async () => {
    try {
      actions.delete(selected.id);

      if (selected.data?.name === "ImageWidget" || selected.data?.name === "ImageWithText") {
        const response = await deleteWheelMedia({
          url: selected.data?.props?.image?.src,
          wheel_id: wheelId
        });
        console.log("Delete API response:", response);
      }
      if (selected.data?.name === "VideoWidget") {
        const response = await deleteWheelMedia({
          url: selected.data?.props?.src,
          wheel_id: wheelId
        });
        console.log("Delete API response:", response);
      }
      if (selected.data?.name === "ImageGridWidget") {
        for (let i = 0; i < selected.data?.props?.images?.length; i++) {
          const response = await deleteWheelMedia({
            url: selected.data?.props?.images[i]?.src,
            wheel_id: wheelId
          });
          console.log("Delete API response:", response);
        }
      }
      if (selected.data?.name === "DocumentWidget") {
        for (let i = 0; i < selected.data?.props?.documents?.length; i++) {
          const response = await deleteWheelMedia({
            url: selected.data?.props?.documents[i]?.src,
            wheel_id: wheelId
          });
          console.log("Delete API response:", response);
        }
      }
      if (selected.data?.name === "AudioWidget") {
        for (let i = 0; i < selected.data?.props?.audios?.length; i++) {
          const response = await deleteWheelMedia({
            url: selected.data?.props?.audios[i]?.src,
            wheel_id: wheelId
          });
          console.log("Delete API response:", response);
        }
      }

      setSelectedTab("0");
    } catch (error) {
      console.error("Error deleting media:", error);
      // Show error toast or notification here if needed
    }
  };

  const handleDelete = () => {
    dispatch(
      openModal({
        onConfirm,
        title: "Delete block",
        subtitle: "Are you sure you want to delete this block?",
      })
    );
  };

  const handleUndo = () => {
    // Check if we are already at the initial state
    const currentState = query.getSerializedNodes();

    if (JSON.stringify(currentState) === JSON.stringify(initialState)) {
      // If the current state is the initial state, prevent further undo
      return;
    }

    if (query.history.canUndo()) {
      actions.history.undo();
    }
  };

  const handleRedo = () => {
    if (query.history.canRedo()) {
      actions.history.redo();
    }
  };

  console.log(query.history, "QUERY HISTORY");
  const currentState = query.getSerializedNodes();

  return (
    <>
      {isEnabled && selected ? (
        <>
          <Box display={"flex"} justifyContent={"space-between"}>
            <Box display={"flex"}>
              <WidgetDisplay name={selected.name} />
            </Box>
            <Box display={"flex"}>
              <UndoRedoComponent
                handleUndo={handleUndo}
                handleRedo={handleRedo}
                canUndo={
                  JSON.stringify(currentState) !== JSON.stringify(initialState)
                } // Now calling canUndo to get the boolean value
                canRedo={query.history.canRedo()} // Now calling canRedo to get the boolean value
              />
              <Box>
                <IconButton
                  color="info"
                  onClick={(e) => {
                    handleClone(e, selected.id);
                  }}
                >
                  <img
                    src={ASSETS.segmentEditor.CopyIcon}
                    alt="Clone Icon"
                    width={22}
                    height={22}
                  />
                </IconButton>
              </Box>
              {selected.isDeletable && (
                <Box>
                  <IconButton color="error" onClick={handleDelete}>
                    <img
                      src={ASSETS.segmentEditor.DeleteIcon}
                      alt="Delete Icon"
                      width={22}
                      height={22}
                    />
                  </IconButton>
                </Box>
              )}
            </Box>
          </Box>
          <Box
            style={{
              height: "74vh",
              overflowY: "scroll",
              scrollbarWidth: "none",
            }}
          >
            <Grid container direction="column" spacing={0}>
              <div data-cy="settings-panel" style={{ width: "100%" }}>
                {selected.settings && React.createElement(selected.settings)}
              </div>
            </Grid>
          </Box>
        </>
      ) : null}
    </>
  );
};
